export default __webpack_public_path__ + "static/media/logo.919f6d10.png";